import { lazy } from 'react';

// ----------------------------------------------------------------------

const ProgramsPage = lazy(() => import('../pages/Programs.page'));
const AddProgramPage = lazy(() => import('../pages/AddProgram'));

// ----------------------------------------------------------------------

const ProgramsRoutes = [
    {
        path: '/programs',
        element: <ProgramsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/programs/add-program',
        element: <AddProgramPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ProgramsRoutes };
